<template>
  <v-content class="dashboard">
    <CandidateDashboard v-if="role === 'candidate'" />
  </v-content>
</template>

<script>
// Mixins
import { managedDocumentAttributes } from '@/mixins/managedDocumentAttributes.js'

// Components
import CandidateDashboard from '@/views/candidates/Dashboard'

// Helpers
import { mapGetters } from 'vuex'

// Vue Component
export default {
  mixins: [managedDocumentAttributes],

  components: { CandidateDashboard },

  created() {
    this.documentAttributes.title = this.role ? `${this.role.capitalize()} Dashboard - Leaply` : 'Dashboard - Leaply'
  },

  computed: {
    ...mapGetters({
      role: 'auth/role',
      fullName: 'auth/fullName',
    }),
  },
}
</script>
